<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col cols="4" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">Strona główna</span>
        <h3 class="page-title">Witaj w panelu</h3>
      </d-col>

      <d-col cols="8" class="text-right">
        <d-button
          theme="primary"
          class="mt-3"
          @click.prevent="downloadReport('seamstress')"
          :disabled="downloadInProgress['seamstress']">
          <template v-if="!downloadInProgress['seamstress']">
            <i class="material-icons">cloud_download</i>
            Raport szwaczek
          </template>
          <template v-if="downloadInProgress['seamstress']">
            <div
              class="spinner-border spinner-border-sm"
              role="status"></div>
          </template>
        </d-button>

        <d-button
          theme="secondary"
          class="ml-2 mt-3"
          @click.prevent="downloadReport('pattern')"
          :disabled="downloadInProgress['pattern']">
          <template v-if="!downloadInProgress['pattern']">
            <i class="material-icons">cloud_download</i>
            Raport wykrajania
          </template>
          <template v-if="downloadInProgress['pattern']">
            <div
              class="spinner-border spinner-border-sm"
              role="status"></div>
          </template>
        </d-button>

        <d-button
          theme="dark"
          class="ml-2 mt-3"
          @click.prevent="downloadReport('orders-to-settlement')"
          :disabled="downloadInProgress['orders_to_settlement']">
          <template v-if="!downloadInProgress['orders_to_settlement']">
            <i class="material-icons">cloud_download</i>
            Zamówienia do rozliczenia
          </template>
          <template v-if="downloadInProgress['orders_to_settlement']">
            <div
              class="spinner-border spinner-border-sm"
              role="status"></div>
          </template>
        </d-button>

        <d-button
          theme="warning"
          class="ml-2 mt-3"
          @click.prevent="openReportPeriodPopup">
          <i class="material-icons">summarize</i>
          Raport kosztowy
        </d-button>
      </d-col>
    </d-row>

    <template v-if="loaded">
      <d-row
        v-for="(group, index) of $options.orderGroups"
        :key="'order-groups-' + index"
        class="my-4 px-3">
        <h4 class="pt-3 mb-4 mt-3">
          {{ group.title }}
        </h4>

        <d-card class="w-100">
          <table class="table mt-0 mb-0 full-width">
            <thead class="bg-light">
              <tr>
                <th scope="col" class="border-0">Nazwa zamówienia</th>
                <th scope="col" class="border-0">Klient</th>
                <th scope="col" class="border-0" style="width: 200px;">Planowana wysyłka</th>
                <th scope="col" class="border-0" style="width: 100px;">Produkty</th>
                <th scope="col" class="border-0" style="width: 100px;">Stan</th>
                <th scope="col" class="border-0" style="width: 130px;">Akcje</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(order, subindex) of (expanded[group.field] ? data[group.field] : shortData[group.field])"
                :key="'order-' + subindex">
                <td class="align-middle">
                  {{ order.order_name }}
                </td>
                <td class="align-middle">
                  {{ order.customer_name }}
                </td>
                <td class="align-middle">
                  <span :class="realizationDateColor(order.planned_shipment_date)">{{ order.planned_shipment_date }}</span>
                </td>
                <td class="align-middle">
                  {{ order.order_products_count }}
                </td>
                <td class="align-middle">
                  <span :class="orderStatus(order)">
                    {{ order.products_done_count }} / {{ order.products_with_procedure_count }}
                  </span>
                </td>
                <td
                  class="align-middle">
                  <d-button
                    theme="primary"
                    @click.native="$router.push('/zamowienia/edycja/' + order.id)"
                    class="mr-2"
                    title="Edytuj">
                    <i class="material-icons">edit</i>
                    Edytuj
                  </d-button>
                </td>
              </tr>
              <tr v-if="data[group.field].length === 0">
                <td
                  colspan="6"
                  class="text-center text-primary">
                  Brak zamówień do wyświetlenia&hellip;
                </td>
              </tr>
            </tbody>
          </table>
        </d-card>

        <d-button
          v-if="data[group.field].length > 5"
          class="w-100 mt-3"
          @click.prevent="expanded[group.field] = !expanded[group.field]">
          <template v-if="expanded[group.field]">Zwiń listę</template>
          <template v-else>Pokaż wszystkie</template>
        </d-button>
      </d-row>

      <d-row
        v-if="data['orders_logs']"
        class="my-4 px-3">
        <h4 class="pt-3 mb-4 mt-3">
          Zmiany w zamówieniach HPL
        </h4>

        <d-card class="w-100">
          <table class="table mt-0 mb-0 full-width">
            <thead class="bg-light">
              <tr>
                <th scope="col" class="border-0" style="width: 100px;">Data</th>
                <th scope="col" class="border-0" style="width: 200px;">Zmiana dotyczy</th>
                <th scope="col" class="border-0" style="width: 150px;">Rodzaj zmiany</th>
                <th scope="col" class="border-0" style="width: 150px;">Zmienione pole</th>
                <th scope="col" class="border-0">Obecna wartość</th>
                <th scope="col" class="border-0">Poprzednia wartość</th>
                <th scope="col" class="border-0" style="width: 120px">Akcje</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(logItem, index) of (expanded['orders_logs'] ? data['orders_logs'] : shortData['orders_logs'])"
                :key="'log-item-' + index">
                <td class="align-middle">
                  <small>{{ logItem.created_at }}</small>
                </td>
                <td class="align-middle">
                  <small v-if="logItem.source === 'ORDER'">
                    Zamówienia
                    <template v-if="logItem.order_id">
                      <br>
                      <span
                        v-if="logItem.order && logItem.order.order_name"
                        class="text-primary">
                        {{ logItem.order.order_name }}
                      </span>
                      <span
                        v-else
                        class="text-primary">
                        Brak nazwy zamówienia
                      </span>
                    </template>
                  </small>
                  <small v-if="logItem.source === 'PRODUCT'">
                    Produktu
                    <template v-if="logItem.product_id">
                      <br>
                        <span
                          v-if="logItem.product"
                          class="text-primary">
                          {{ logItem.product.name }}
                        </span>
                        <span
                          v-else
                          class="text-primary">
                          Brak nazwy produktu
                        </span>
                    </template>
                  </small>
                </td>
                <td class="align-middle">
                  <small v-if="logItem.action === 'ADD'" class="text-success">Dodanie</small>
                  <small v-if="logItem.action === 'UPDATE'" class="text-warning">Aktualizacja</small>
                  <small v-if="logItem.action === 'DELETE'" class="text-danger">Usunięcie</small>
                  <small v-if="logItem.action === 'CANCEL'" class="text-dark">Anulowanie</small>
                </td>
                <td class="align-middle">
                  <small v-if="logItem.field">{{ getFieldName(logItem.field) }}</small>
                  <small v-else>&mdash;</small>
                </td>
                <td class="align-middle">
                  <small v-if="logItem.value" class="text-success">{{ logItem.value }}</small>
                  <small v-else>&mdash;</small>
                </td>
                <td class="align-middle">
                  <small v-if="logItem.prev_value" class="text-danger">{{ logItem.prev_value }}</small>
                  <small v-else>&mdash;</small>
                </td>
                <td class="align-middle">
                  <d-button
                    v-if="logItem.order"
                    @click.prevent="$router.push('/zamowienia/edycja/' + logItem.order.id)">
                    <i class="material-icons">visibility</i>
                    Zobacz
                  </d-button>
                </td>
              </tr>

              <tr v-if="data['orders_logs'].length === 0">
                <td
                  colspan="6"
                  class="text-center text-primary">
                  Brak zmian do wyświetlenia&hellip;
                </td>
              </tr>
            </tbody>
          </table>
        </d-card>

        <d-button
          v-if="data['orders_logs'] && data['orders_logs'].length > 5"
          class="w-100 mt-3"
          @click.prevent="expanded['orders_logs'] = !expanded['orders_logs']">
          <template v-if="expanded['orders_logs']">Zwiń listę</template>
          <template v-else>Pokaż wszystkie</template>
        </d-button>
      </d-row>
    </template>

    <d-modal
      v-if="showReportPeriodPopup"
      @close="showReportPeriodPopup = false">
      <d-modal-header>
        <d-modal-title>
          Wybierz okres dla raportu kosztowego
        </d-modal-title>
      </d-modal-header>
      <d-modal-body class="p-3">
        <date-range-picker
          ref="picker"
          :locale-data="{
            'firstDay': 1,
            'format': 'DD-MM-YYYY',
            'daysOfWeek': ['Ndz', 'Pon', 'Wto', 'Śro', 'Czw', 'Ptk', 'Sob'],
            'monthNames': ['Sty', 'Lut', 'Mar', 'Kwi', 'Maj', 'Cze', 'Lip', 'Sie', 'Wrz', 'Paź', 'Lis', 'Gru'],
          }"
          class="w-100"
          :singleDatePicker="false"
          :timePicker="false"
          :showWeekNumbers="false"
          :showDropdowns="false"
          :autoApply="true"
          v-model="reportPeriod"
          :ranges="false"
          :linkedCalendars="true">
          <template v-slot:input="picker" style="min-width: 350px;">
            {{ picker.startDate | dateStart }} - {{ picker.endDate | dateEnd }}
          </template>
        </date-range-picker>
      </d-modal-body>
      <d-modal-footer>
        <d-button
          class="ml-auto mr-auto"
          theme="success"
          :disabled="!reportPeriod.startDate || !reportPeriod.endDate"
          @click.prevent="downloadReport('users-costs', reportPeriod)">
          <template v-if="!downloadInProgress['users_costs']">
            Generuj raport
          </template>
          <template v-if="downloadInProgress['users_costs']">
            <div
              class="spinner-border spinner-border-sm"
              role="status"></div>
          </template>
        </d-button>
      </d-modal-footer>
    </d-modal>
  </d-container>
</template>

<script>
import DateRangePicker from 'vue2-daterange-picker';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import ListUtils from './../utils/ListUtils.js';
import Vue from 'vue';

export default {
  name: 'dashboard',
  components: {
    'date-range-picker': DateRangePicker
  },
  orderGroups: [
    {
      field: 'new_orders',
      title: 'Nowe zamówienia:'
    },
    {
      field: 'to_pattern',
      title: 'Zamówienia do wykrojenia:'
    },
    {
      field: 'in_production',
      title: 'Zamówienia w produkcji:'
    },
    {
      field: 'without_date',
      title: 'Zamówienia bez przypisanych terminów:'
    },
    {
      field: 'passed',
      title: 'Zamówienia, którym minął termin:'
    },
    {
      field: 'different_quantity',
      title: 'Zamówienia z niezgodną ilością:'
    }
  ],
  filters: {
    dateStart (input) {
      if (input === null) {
        return ' szukaj od ';
      }

      return [input.getFullYear(), input.getMonth() + 1, input.getDate()].map(n => n < 10 ? '0' + n : n).join('-');
    },
    dateEnd (input) {
      if (input === null) {
        return ' do ';
      }

      return [input.getFullYear(), input.getMonth() + 1, input.getDate()].map(n => n < 10 ? '0' + n : n).join('-');
    }
  },
  data() {
    return {
      data: {
        new_orders: [],
        to_pattern: [],
        in_production: [],
        without_date: [],
        passed: [],
        different_quantity: [],
        orders_logs: []
      },
      shortData: {
        new_orders: [],
        to_pattern: [],
        in_production: [],
        without_date: [],
        passed: [],
        different_quantity: [],
        orders_logs: []
      },
      expanded: {
        new_orders: false,
        to_pattern: false,
        in_production: false,
        without_date: false,
        passed: false,
        different_quantity: false,
        orders_logs: false
      },
      loaded: false,
      showReportPeriodPopup: false,
      reportPeriod: {
        startDate: null,
        endDate: null
      },
      downloadInProgress: {
        pattern: false,
        seamstress: false,
        orders_to_settlement: false,
        users_costs: false
      }
    };
  },
  watch: {
    loaded () {
      this.shortData['new_orders'] = this.data['new_orders'].slice(0, 5);
      this.shortData['to_pattern'] = this.data['to_pattern'].slice(0, 5);
      this.shortData['in_production'] = this.data['in_production'].slice(0, 5);
      this.shortData['without_date'] = this.data['without_date'].slice(0, 5);
      this.shortData['passed'] = this.data['passed'].slice(0, 5);
      this.shortData['different_quantity'] = this.data['different_quantity'].slice(0, 5);
      this.shortData['orders_logs'] = this.data['orders_logs'].slice(0, 5);
    }
  },
  mounted () {
    this.loadData();
  },
  methods: {
    loadData () {
      ListUtils.loadItemsData(this, {
        endpoint: '/dashboard/lists',
        listField: ['new_orders', 'to_pattern', 'in_production', 'without_date', 'passed', 'different_quantity', 'orders_logs'],
        noDataField: true,
        pagination: false
      });
    },
    downloadReport (reportType, datesFromPopup = false) {
      let downloadFlag = reportType.replace(/-/gmi, '_');
      Vue.set(this.downloadInProgress, downloadFlag, true);
      let payload = {};

      if (datesFromPopup) {
        let start = this.reportPeriod.startDate;
        let end = this.reportPeriod.endDate;
        start = [start.getFullYear(), start.getMonth() + 1, start.getDate()].map(n => n < 10 ? '0' + n : n).join('-');
        end = [end.getFullYear(), end.getMonth() + 1, end.getDate()].map(n => n < 10 ? '0' + n : n).join('-');

        payload = {
          date_from: start,
          date_to: end
        };
      }

      this.$http.post('/reports/' + reportType, payload, {
        responseType: 'blob'
      }).then((response) => {
        let fileNamePrefix = 'raport-szwaczek-';
        let fileExtension = '.pdf';

        if (datesFromPopup) {
          this.showReportPeriodPopup = false;
        }

        if (reportType === 'pattern') {
          fileNamePrefix = 'raport-wykrajania-';
          fileExtension = '.xlsx';
        } else if (reportType === 'orders-to-settlement') {
          fileNamePrefix = 'zamowienia-do-rozliczenia-';
          fileExtension = '.xlsx';
        } else if (reportType === 'users-costs') {
          fileNamePrefix = 'raport-kosztowy-';
          fileExtension = '.xlsx';
        }

        let link = document.createElement('a');
        link.href = URL.createObjectURL(new Blob([response.data]));
        link.setAttribute('download', fileNamePrefix + this.generateDateSuffix() + fileExtension);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        Vue.set(this.downloadInProgress, downloadFlag, false);
      }).catch(() => {
        Vue.set(this.downloadInProgress, downloadFlag, false);
      });
    },
    generateDateSuffix () {
      let date = new Date();
      let output = [date.getFullYear(), date.getMonth() + 1, date.getDate()];
      output = output.map(n => n < 10 ? '0' + n : n);
      return output.join('-');
    },
    realizationDateColor (dateToCheck) {
      let timestamp = +new Date(dateToCheck);
      let currentTimestamp = +new Date();

      if (timestamp - currentTimestamp < 0) {
        return 'text-danger font-weight-bold';
      } else if (timestamp - currentTimestamp < 4 * 24 * 60 * 60 * 1000) {
        return 'text-warning';
      }

      return 'text-primary';
    },
    orderStatus (orderData) {
      if (orderData.products_with_procedure_count < orderData.order_products_count) {
        return 'text-danger';
      } else if (
        orderData.products_with_procedure_count === orderData.order_products_count &&
        orderData.products_done_count === orderData.order_products_count
      ) {
        return 'text-success';
      }

      return 'text-dark';
    },
    openReportPeriodPopup () {
      this.reportPeriod.startDate = null;
      this.reportPeriod.endDate = null;
      this.showReportPeriodPopup = true;
    },
    getFieldName (field) {
      switch (field) {
        case 'crm_has_order_file': return 'Plik zamówienia';
        case 'customer_name': return 'Nazwa klienta';
        case 'order_name': return 'Nazwa zamówienia';
        case 'planned_shipment_date': return 'Planowana data wysyłki';
        case 'description': return 'Opis';
        case 'product_id': return 'ID produktu';
        case 'name': return 'Nazwa produktu';
        case 'code': return 'Kod produktu';
        case 'size_name': return 'Rozmiar';
        case 'polar_name': return 'Polar';
        case 'color_name': return 'Kolor';
        case 'material_name': return 'Materiał';
        case 'pattern_required': return 'Wymaga wykroju';
        case 'pattern_before_order': return 'Wykrajanie przed zamówieniem';
        case 'quantity': return 'Ilość';
        case 'pattern_stays': return 'Wykrój zostaje w hafciarni';
        default: return '-';
      }
    }
  }
};
</script>

